import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import { Dialog, Transition } from "@headlessui/react";
import AOS from "aos";
import "aos/dist/aos.css";

import Building from "../../Assets/Image/building.png";
import MapBg from "../../Assets/Image/9267.jpg";

import Content1 from "../../Assets/Content/Cabling.jpg";
import Content2 from "../../Assets/Content/DataCenter.jpg";
import Content3 from "../../Assets/Content/DataCenterDua.jpg";
import Content4 from "../../Assets/Content/Itconsultant.png";
import Content5 from "../../Assets/Content/VirtualizationCloud.jpg";
import Content6 from "../../Assets/Content/AppDev.jpg";
import Content7 from "../../Assets/Content/RBteam.png";
import Content8 from "../../Assets/Content/Hardware.jpeg";

import Thumbnail1 from "../../Assets/Content/thumbnail1.png";
import Thumbnail2 from "../../Assets/Content/thumbnail2.png";
import Thumbnail3 from "../../Assets/Content/thumbnail3.jpg";
import Thumbnail4 from "../../Assets/Content/thumbnail4.png";
import Thumbnail5 from "../../Assets/Content/thumnail5.png";
import Thumbnail6 from "../../Assets/Content/thumbnail6.jpg";

const projects = [
  {
    id: 1,
    image: Content1,
    title: "Cabling & Maintenance",
    category: "Infrastructure",
    description:
      "Structured cabling, installation, maintenance, and infrastructure support for reliable enterprise connectivity.",
  },
  {
    id: 2,
    image: Content2,
    title: "Data Center Facility & Service",
    category: "Data Center",
    description:
      "Data center facility implementation and technical services supporting secure, resilient, and efficient operations.",
  },
  {
    id: 3,
    image: Content3,
    title: "Data Center Infrastructure",
    category: "Data Center",
    description:
      "Infrastructure deployment and optimization for critical systems, server environments, and supporting facilities.",
  },
  {
    id: 4,
    image: Content4,
    title: "IT Consulting",
    category: "Consulting",
    description:
      "Technology advisory and project support to align business requirements with practical IT solutions.",
  },
  {
    id: 5,
    image: Content5,
    title: "Virtualization & Cloud Solutions",
    category: "Cloud",
    description:
      "Virtualization and cloud implementation services designed to improve flexibility, scalability, and resource efficiency.",
  },
  {
    id: 6,
    image: Content6,
    title: "Application Development & Implementation",
    category: "Application",
    description:
      "Development and implementation of business applications that support digital operations and service delivery.",
  },
  {
    id: 7,
    image: Content7,
    title: "Red Team & Blue Team",
    category: "Cybersecurity",
    description:
      "Offensive and defensive security activities to evaluate readiness, improve detection, and strengthen cyber resilience.",
  },
  {
    id: 8,
    image: Content8,
    title: "Hardware & IT Integration",
    category: "Integration",
    description:
      "Deployment and integration of enterprise hardware and systems into a unified, operational environment.",
  },
];

const gallery = [
  { id: 1, image: Thumbnail1, title: "Project Documentation 01" },
  { id: 2, image: Thumbnail2, title: "Project Documentation 02" },
  { id: 3, image: Thumbnail3, title: "Project Documentation 03" },
  { id: 4, image: Thumbnail4, title: "Project Documentation 04" },
  { id: 5, image: Thumbnail5, title: "Project Documentation 05" },
  { id: 6, image: Thumbnail6, title: "Project Documentation 06" },
];

const stats = [
  {
    value: "25+",
    label: "Clients & Partners",
    description: "Organizations and technology partners across our ecosystem.",
  },
  {
    value: "572+",
    label: "Completed Projects",
    description: "Technology projects delivered across multiple solution areas.",
  },
  {
    value: "99%",
    label: "Customer Satisfaction",
    description: "Commitment to dependable delivery and service quality.",
  },
];

export default function Advantage() {
  const [selectedProject, setSelectedProject] = React.useState(null);
  const [selectedGallery, setSelectedGallery] = React.useState(null);

  React.useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
      offset: 80,
    });
  }, []);

  return (
    <main className="overflow-hidden bg-white text-slate-900">
      {/* Hero */}
      <section className="px-4 pt-4 sm:px-6 lg:px-8">
        <div
          className="relative min-h-[620px] overflow-hidden rounded-[28px] bg-cover bg-center shadow-[0_30px_80px_rgba(15,44,72,0.22)] lg:min-h-[690px]"
          style={{ backgroundImage: `url(${Building})` }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-[#071C33]/95 via-[#123A60]/88 to-[#123A60]/35" />
          <div className="absolute -right-28 top-20 h-96 w-96 rounded-full bg-[#2392D0]/20 blur-3xl" />
          <div className="absolute -bottom-40 left-1/3 h-96 w-96 rounded-full bg-white/10 blur-3xl" />

          <div className="relative z-10 mx-auto flex min-h-[620px] max-w-7xl items-center px-6 py-24 sm:px-10 lg:min-h-[690px] lg:px-16">
            <div className="max-w-3xl" data-aos="fade-up">
              <div className="mb-6 inline-flex items-center gap-3 rounded-full border border-white/20 bg-white/10 px-4 py-2 backdrop-blur-md">
                <span className="h-2.5 w-2.5 rounded-full bg-[#42B6F5]" />
                <span className="text-sm font-semibold uppercase tracking-[0.18em] text-white/90">
                  Project Experience
                </span>
              </div>

              <h1 className="text-4xl font-semibold leading-tight text-white sm:text-5xl lg:text-7xl">
                Real projects.
                <span className="block text-[#58BFF4]">Proven delivery.</span>
              </h1>

              <p className="mt-7 max-w-2xl text-base leading-8 text-slate-200 sm:text-lg">
                Explore Viktorindo project documentation across infrastructure,
                cybersecurity, data center, application, cloud, and system
                integration initiatives.
              </p>

              <div className="mt-10 flex flex-col gap-4 sm:flex-row">
                <a
                  href="#project-showcase"
                  className="inline-flex items-center justify-center gap-3 rounded-full bg-[#2392D0] px-7 py-3.5 text-sm font-semibold text-white shadow-lg shadow-[#2392D0]/25 transition duration-300 hover:-translate-y-1 hover:bg-[#1D82BB]"
                >
                  View Our Projects
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    className="h-5 w-5"
                    aria-hidden="true"
                  >
                    <path
                      d="M12 5v14M6 13l6 6 6-6"
                      stroke="currentColor"
                      strokeWidth="1.8"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </a>

                <Link
                  to="/#contact"
                  className="inline-flex items-center justify-center rounded-full border border-white/30 bg-white/10 px-7 py-3.5 text-sm font-semibold text-white backdrop-blur-md transition duration-300 hover:bg-white hover:text-[#123A60]"
                >
                  Discuss Your Project
                </Link>
              </div>
            </div>
          </div>

          <div className="absolute bottom-0 right-0 hidden rounded-tl-[40px] border-l border-t border-white/15 bg-white/10 px-10 py-8 backdrop-blur-xl lg:block">
            <p className="text-xs font-semibold uppercase tracking-[0.18em] text-white/60">
              Our Strength
            </p>
            <p className="mt-2 max-w-xs text-lg font-medium leading-7 text-white">
              Practical execution backed by experienced technical teams.
            </p>
          </div>
        </div>
      </section>

      {/* Introduction */}
      <section className="mx-auto max-w-7xl px-5 py-24 sm:px-6 lg:px-8 lg:py-28">
        <div className="grid gap-12 lg:grid-cols-[0.8fr_1.2fr] lg:items-end">
          <div data-aos="fade-right">
            <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#2392D0]">
              Delivery Experience
            </p>
            <h2 className="mt-4 text-3xl font-semibold leading-tight text-[#123A60] sm:text-4xl lg:text-5xl">
              Technology capability demonstrated through implementation.
            </h2>
          </div>

          <div data-aos="fade-left">
            <p className="leading-8 text-slate-600">
              Our project portfolio reflects the breadth of our capabilities,
              from physical infrastructure and data center environments to
              cybersecurity, cloud, application systems, and enterprise
              integration. Each engagement is delivered with clear planning,
              technical coordination, implementation discipline, and operational
              readiness.
            </p>
          </div>
        </div>
      </section>

      {/* Project showcase */}
      <section id="project-showcase" className="bg-[#F4F8FC] py-24 lg:py-32">
        <div className="mx-auto max-w-7xl px-5 sm:px-6 lg:px-8">
          <div className="max-w-3xl" data-aos="fade-up">
            <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#2392D0]">
              Project Showcase
            </p>
            <h2 className="mt-4 text-3xl font-semibold leading-tight text-[#123A60] sm:text-4xl lg:text-5xl">
              Selected implementation and service documentation.
            </h2>
            <p className="mt-6 leading-8 text-slate-600">
              Click any project card to view the documentation image in greater
              detail.
            </p>
          </div>

          <div className="mt-14 grid gap-7 md:grid-cols-2">
            {projects.map((project, index) => (
              <button
                key={project.id}
                type="button"
                onClick={() => setSelectedProject(project)}
                className="group relative min-h-[360px] overflow-hidden rounded-[28px] text-left shadow-[0_20px_60px_rgba(18,58,96,0.12)] outline-none focus-visible:ring-4 focus-visible:ring-[#2392D0]/30"
                data-aos="fade-up"
                data-aos-delay={(index % 2) * 100}
              >
                <img
                  src={project.image}
                  alt={project.title}
                  className="absolute inset-0 h-full w-full object-cover transition duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#071C33]/95 via-[#123A60]/35 to-transparent" />

                <div className="absolute inset-x-0 bottom-0 p-7 sm:p-8">
                  <span className="inline-flex rounded-full border border-white/20 bg-white/10 px-3 py-1 text-xs font-semibold uppercase tracking-[0.14em] text-[#8AD6FA] backdrop-blur-md">
                    {project.category}
                  </span>

                  <h3 className="mt-4 text-2xl font-semibold text-white sm:text-3xl">
                    {project.title}
                  </h3>

                  <p className="mt-3 max-w-xl text-sm leading-7 text-slate-200 sm:text-base">
                    {project.description}
                  </p>

                  <div className="mt-5 inline-flex items-center gap-3 text-sm font-semibold text-white">
                    View Documentation
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      className="h-5 w-5 transition duration-300 group-hover:translate-x-1"
                      aria-hidden="true"
                    >
                      <path
                        d="M5 12h14M13 6l6 6-6 6"
                        stroke="currentColor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                </div>
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="px-4 py-24 sm:px-6 lg:px-8 lg:py-32">
        <div
          className="relative mx-auto max-w-7xl overflow-hidden rounded-[32px] bg-cover bg-center px-6 py-16 shadow-[0_30px_80px_rgba(18,58,96,0.20)] sm:px-10 lg:px-16 lg:py-20"
          style={{ backgroundImage: `url(${MapBg})` }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-white/96 via-white/90 to-white/75" />
          <div className="absolute -right-20 -top-20 h-80 w-80 rounded-full bg-[#2392D0]/15 blur-3xl" />

          <div className="relative z-10 text-center" data-aos="fade-up">
            <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#2392D0]">
              Project by Numbers
            </p>
            <h2 className="mx-auto mt-4 max-w-3xl text-3xl font-semibold leading-tight text-[#123A60] sm:text-4xl lg:text-5xl">
              Experience measured through trust and completed delivery.
            </h2>
          </div>

          <div className="relative z-10 mt-14 grid gap-6 md:grid-cols-3">
            {stats.map((stat, index) => (
              <article
                key={stat.label}
                className="rounded-[24px] border border-white/60 bg-white/75 p-7 text-center shadow-sm backdrop-blur-md"
                data-aos="fade-up"
                data-aos-delay={index * 100}
              >
                <p className="text-5xl font-semibold text-[#2392D0] sm:text-6xl">
                  {stat.value}
                </p>
                <h3 className="mt-4 text-xl font-semibold text-[#123A60]">
                  {stat.label}
                </h3>
                <p className="mt-3 leading-7 text-slate-600">
                  {stat.description}
                </p>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Documentation gallery */}
      <section className="bg-[#F4F8FC] py-24 lg:py-32">
        <div className="mx-auto max-w-7xl px-5 sm:px-6 lg:px-8">
          <div className="mx-auto max-w-3xl text-center" data-aos="fade-up">
            <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#2392D0]">
              Field Documentation
            </p>
            <h2 className="mt-4 text-3xl font-semibold leading-tight text-[#123A60] sm:text-4xl lg:text-5xl">
              A closer look at our work in the field.
            </h2>
            <p className="mt-6 leading-8 text-slate-600">
              Documentation from project activities, technical implementation,
              installation, integration, and customer environments.
            </p>
          </div>

          <div className="mt-14 grid auto-rows-[220px] gap-5 sm:grid-cols-2 lg:grid-cols-4">
            {gallery.map((item, index) => {
              const featured = index === 0 || index === 3;

              return (
                <button
                  key={item.id}
                  type="button"
                  onClick={() => setSelectedGallery(item)}
                  className={`group relative overflow-hidden rounded-[24px] text-left shadow-sm outline-none focus-visible:ring-4 focus-visible:ring-[#2392D0]/30 ${
                    featured ? "sm:row-span-2 lg:col-span-2" : ""
                  }`}
                  data-aos="fade-up"
                  data-aos-delay={(index % 4) * 70}
                >
                  <img
                    src={item.image}
                    alt={item.title}
                    className="absolute inset-0 h-full w-full object-cover transition duration-700 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#071C33]/75 via-transparent to-transparent opacity-80 transition duration-300 group-hover:opacity-100" />

                  <div className="absolute inset-x-0 bottom-0 flex items-end justify-between gap-4 p-5">
                    <p className="font-semibold text-white">{item.title}</p>
                    <span className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full border border-white/20 bg-white/10 text-white backdrop-blur-md">
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        className="h-5 w-5"
                        aria-hidden="true"
                      >
                        <path
                          d="m15 9 6-6M16 3h5v5M9 15l-6 6M8 21H3v-5"
                          stroke="currentColor"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </span>
                  </div>
                </button>
              );
            })}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="px-4 py-24 sm:px-6 lg:px-8 lg:py-32">
        <div className="relative mx-auto max-w-7xl overflow-hidden rounded-[30px] bg-gradient-to-r from-[#123A60] to-[#2173AA] px-6 py-14 sm:px-10 lg:flex lg:items-center lg:justify-between lg:px-14">
          <div className="absolute -right-12 -top-24 h-72 w-72 rounded-full border border-white/10" />
          <div className="absolute -right-4 -top-14 h-52 w-52 rounded-full border border-white/10" />

          <div className="relative z-10 max-w-2xl">
            <p className="text-sm font-bold uppercase tracking-[0.18em] text-[#78CDF8]">
              Your Next Project
            </p>
            <h2 className="mt-3 text-3xl font-semibold leading-tight text-white sm:text-4xl">
              Ready to deliver your next technology initiative?
            </h2>
            <p className="mt-4 leading-7 text-slate-200">
              Discuss your infrastructure, security, cloud, application, or
              integration requirements with our technical team.
            </p>
          </div>

          <div className="relative z-10 mt-8 lg:mt-0">
            <Link
              to="/#contact"
              className="inline-flex items-center justify-center gap-3 rounded-full bg-white px-7 py-3.5 text-sm font-semibold text-[#123A60] transition duration-300 hover:-translate-y-1 hover:shadow-xl"
            >
              Contact Our Team
              <svg
                viewBox="0 0 24 24"
                fill="none"
                className="h-5 w-5"
                aria-hidden="true"
              >
                <path
                  d="M5 12h14M13 6l6 6-6 6"
                  stroke="currentColor"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </Link>
          </div>
        </div>
      </section>

      <ImageModal
        open={Boolean(selectedProject)}
        item={selectedProject}
        onClose={() => setSelectedProject(null)}
      />

      <ImageModal
        open={Boolean(selectedGallery)}
        item={
          selectedGallery
            ? {
                ...selectedGallery,
                description:
                  "Project and implementation documentation from Viktorindo Teknologi Prima.",
              }
            : null
        }
        onClose={() => setSelectedGallery(null)}
      />
    </main>
  );
}

function ImageModal({ open, item, onClose }) {
  const closeButtonRef = React.useRef(null);

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-50"
        initialFocus={closeButtonRef}
        onClose={onClose}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-[#071C33]/90 backdrop-blur-sm" />
        </Transition.Child>

        <div className="fixed inset-0 z-50 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 sm:p-6">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 scale-95"
              enterTo="opacity-100 translate-y-0 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 scale-100"
              leaveTo="opacity-0 translate-y-4 scale-95"
            >
              <Dialog.Panel className="relative w-full max-w-5xl overflow-hidden rounded-[28px] bg-white shadow-2xl">
                <button
                  ref={closeButtonRef}
                  type="button"
                  onClick={onClose}
                  className="absolute right-4 top-4 z-20 flex h-11 w-11 items-center justify-center rounded-full bg-[#071C33]/75 text-white backdrop-blur-md transition hover:bg-[#071C33]"
                  aria-label="Close image preview"
                >
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    className="h-6 w-6"
                    aria-hidden="true"
                  >
                    <path
                      d="M6 6l12 12M18 6 6 18"
                      stroke="currentColor"
                      strokeWidth="1.8"
                      strokeLinecap="round"
                    />
                  </svg>
                </button>

                {item && (
                  <>
                    <div className="flex min-h-[320px] items-center justify-center bg-slate-100 sm:min-h-[480px]">
                      <img
                        src={item.image}
                        alt={item.title}
                        className="max-h-[75vh] w-full object-contain"
                      />
                    </div>

                    <div className="p-6 sm:p-8">
                      {item.category && (
                        <p className="text-xs font-bold uppercase tracking-[0.18em] text-[#2392D0]">
                          {item.category}
                        </p>
                      )}

                      <Dialog.Title className="mt-2 text-2xl font-semibold text-[#123A60] sm:text-3xl">
                        {item.title}
                      </Dialog.Title>

                      {item.description && (
                        <Dialog.Description className="mt-4 max-w-3xl leading-7 text-slate-600">
                          {item.description}
                        </Dialog.Description>
                      )}
                    </div>
                  </>
                )}
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}